import React, { useEffect, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { FunctionalLoader } from 'seagull';
import { useOnMount } from "../../hooks/useOnMount";
import { useStore, useStoreActions } from "../../contexts";
import { routes } from "../../constants";
import { selectors } from "../../store/state-selectors";
import { DesktopPane } from "../components/ClientFlowStructure/DesktopPane/DesktopPane";
import { ResponsiveProvider } from "../contexts";
import { ApproveDelivery } from "./ApproveDelivery";
import { DownloadFiles } from "./DownloadFiles";
import { ReviewDelivery } from "./ReviewDelivery";
import { DeliveryRejected } from "./DeliveryRejected";
import { DeliveryWithdrawn } from "./DeliveryWithdrawn";
import styles from "./ServiceDeliveryApproval.module.scss";
import { relationshipModel } from "../../models";
import { CobConfigProvider } from "../clientOb/CobConfigContext";
const STEPS_NAMES = ['Review delivery', 'Approve delivery'];
const STEPS_COMPS = [ReviewDelivery, ApproveDelivery, DownloadFiles, DeliveryRejected, DeliveryWithdrawn];
export function ServiceDeliveryApprovalInner(_ref) {
  let {
    relationship,
    service,
    billCommand
  } = _ref;
  const userEmail = useStore(selectors.user.email);
  const {
    logBI,
    setRelationshipScope
  } = useStoreActions();
  const [activeStep, setActiveStep] = useState(() => {
    switch (billCommand.status) {
      case 'inProgress':
        return STEPS_COMPS.indexOf(DeliveryWithdrawn);

      case 'rejected':
        return STEPS_COMPS.indexOf(DeliveryRejected);

      case 'active':
        return STEPS_COMPS.indexOf(DownloadFiles);

      default:
        return 0;
    }
  });
  useOnMount(() => {
    setRelationshipScope({
      id: relationship.id,
      isApproved: relationshipModel.isApproved(relationship)
    });
    logBI(11702);
    return () => setRelationshipScope(null);
  });
  const Component = STEPS_COMPS[activeStep];

  if (relationship.seller.email === userEmail && !relationship.isSample || !relationshipModel.isApproved(relationship)) {
    // vendor tries to approve the delivery or the agreement was terminated
    return /*#__PURE__*/React.createElement(Redirect, {
      to: routes.agreement(relationship.id)
    });
  }

  return /*#__PURE__*/React.createElement(ResponsiveProvider, {
    disableMobile: true
  }, /*#__PURE__*/React.createElement(CobConfigProvider, {
    relationship: relationship
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, activeStep <= 2 && /*#__PURE__*/React.createElement(DesktopPane, {
    stepperSteps: STEPS_NAMES,
    activeStepIndex: activeStep,
    "data-testid": "sda-sidebar"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Component, {
    relationship: relationship,
    service: service,
    billCommand: billCommand,
    onNextBtnClick: () => setActiveStep(activeStep + 1),
    onBackBtnClick: () => setActiveStep(activeStep - 1),
    rejectDelivery: () => setActiveStep(STEPS_COMPS.indexOf(DeliveryRejected))
  })))));
}
export function ServiceDeliveryApproval() {
  const {
    relationshipId,
    serviceId
  } = useParams();
  const {
    api
  } = useStoreActions();
  const [data, setData] = useState();
  useEffect(() => {
    (async () => {
      try {
        const billCommands = await api.billCommand.get(relationshipId, serviceId);
        const relationship = await api.relationship.get(relationshipId);
        const service = relationship === null || relationship === void 0 ? void 0 : relationship.services.find(service => service.id === serviceId);
        setData({
          service,
          billCommand: billCommands === null || billCommands === void 0 ? void 0 : billCommands[0],
          relationship: relationship !== null && relationship !== void 0 ? relationship : undefined
        });
      } catch (_unused) {
        setData();
      }
    })();
  }, [relationshipId, serviceId]);

  if (!data) {
    return /*#__PURE__*/React.createElement(FunctionalLoader, {
      name: "ServiceDeliveryApproval",
      show: true
    });
  } else if (!data.billCommand || !data.relationship || !data.service) {
    throw new Error('bad response');
  } else {
    return /*#__PURE__*/React.createElement(ServiceDeliveryApprovalInner, {
      relationship: data.relationship,
      service: data.service,
      billCommand: data.billCommand
    });
  }
}